import script from "./TheSearchFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSearchFilter.vue?vue&type=script&setup=true&lang=js"

import "./TheSearchFilter.vue?vue&type=style&index=0&id=1059fbee&lang=scss&scoped=true"
script.__scopeId = "data-v-1059fbee"

export default script